query getInvite($custom_invite: String) {
    getInvite(custom_invite: $custom_invite) {
        custom_invite
        uuid
        language
        custom_text
        disabled
    }
}
